import React, { useState } from 'react'
import { withStyles, Typography, Paper, Collapse, Checkbox, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import clsx from 'clsx';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown'
import getObjectValue from 'libs/getObjectValue';
import Tr from 'translations/Translations';

const style = theme => ({
	root: {

	},
	title: {
		backgroundColor: theme.palette.background.greyBackground,
		border: `1px solid ${theme.palette.common.white}`,
		cursor: 'pointer',
		'&>*:nth-child(2)': {
			flexGrow: 1,
		}
	},
	padding: {
		padding: theme.spacing(1) / 2,
	},
	rotate: {
		transform: 'rotate(180deg)'
	},
	arrow: {
		padding: theme.spacing(1),
	},
	noCheckbox: {
		marginLeft: theme.spacing(2)
	}
})

function Section({
	classes,
	id,
	formikProps,
	title,
	description,
	children,
	disabled,
	checked
}) {
	const [open, setOpen] = useState(false)
	const editable = getObjectValue('_editable', formikProps.values, true);

	const isChecked = () => {
		const elements = getObjectValue(id, formikProps.values);
		for (let key in elements) {
			if (elements[key]) return true;
		}
		return false;
	}
	const handleChange = () => {

		const elements =  getObjectValue(id, formikProps.values);
		if (isChecked()) {
			for (let key in elements) {
				if (elements[key]) formikProps.setFieldValue(`${id}.${key}`, false);
			}
			return
		} else {
			for (let key in elements) {
				formikProps.setFieldValue(`${id}.${key}`, true)
			}
		}
	}

	const checkedValue = checked ? checked : isChecked()
	return (
		<Paper
			elevation={0}
		>
			<GridBlock
				column
				className={classes.root}
			>
				<GridBlock
					wrap='nowrap'
					alignItems='center'
					className={clsx(
						classes.padding,
						classes.title
					)}
				>
					{id &&
						<Tooltip title={checkedValue ? Tr('checkbox_uncheck') : Tr('checkbox_check')}>
							<Checkbox
								color='primary'
								checked={checkedValue}
								onChange={handleChange}
								disabled={disabled || !editable}
							/>
						</Tooltip>
					}
					<Typography
						variant='h5'
						onClick={() => setOpen(!open)}
						className={clsx({
							[classes.noCheckbox]: !Boolean(id)
						})}
					>
						{title}
					</Typography>
					<Tooltip title={open ? Tr('collapse') : Tr('expand')} placement='top'>
						<ArrowIcon
							onClick={() => setOpen(!open)}
							className={clsx(classes.arrow, {
								[classes.rotate]: open
							})}
						/>
					</Tooltip>
				</GridBlock>
				<Typography
					variant='body1'
					className={classes.padding}
				>
					{description}
				</Typography>
				<Collapse in={open}>
					<div
						className={classes.padding}
					>
						{children}
					</div>
				</Collapse>
			</GridBlock>
		</Paper>
	)
}

Section.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(Section);